import { RoleManagement } from "@/components/admin/RoleManagement";

export const AdminTeam = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Roles and Permissions</h1>
        <p className="text-muted-foreground">Manage team roles and access levels</p>
      </div>
      
      <RoleManagement />
    </div>
  );
};
